import { Typography } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

import { constants } from '@hero/configs';

const DigitalWrapperSelect = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: center;
  min-width: 350px;

  ${Typography.S.Typography} {
    white-space: nowrap;
  }
`;

const DigitalWrapperFeaturedHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
`;

const DigitalWrapper = styled.div`
  border: 1px solid var(--color-border-default);
  border-bottom-left-radius: var(--size-border-radius-md);
  border-bottom-right-radius: var(--size-border-radius-md);
  padding: 16px 24px;
  position: relative;

  .tab-button {
    font-size: 14px;
    padding: 0 16px;
  }

  ${constants?.products?.card?.width &&
  css`
    img {
      object-position: top left;
      transform: scale(2.5);
      transform-origin: top left;
    }
  `}
`;

const ImagePreviewWrapper = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fill, minmax(66px, 1fr));
  margin-bottom: 16px;
  margin-top: 12px;
`;

const DigitalWrapperTitle = styled.div`
  margin-bottom: 16px;
`;

const UploadImageButtonWrapper = styled.div`
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-lg);
  cursor: pointer;
  height: 70px;
  opacity: 0.4;
  padding: 6px;
  width: 70px;

  ${Typography.S.Typography} {
    font-size: 12px;
  }

  :hover {
    border-color: var(--color-border-strong);
  }

  ${({ error }) =>
    error &&
    css`
      border: 2px solid var(--color-error-default);
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      &,
      ${UploadButton} {
        opacity: 0.4;
      }

      :hover {
        border-color: var(--color-border-default);
      }
    `}
`;

const UploadButton = styled.button`
  align-items: center;
  background-color: transparent;
  border: 2px dashed var(--color-border-strong);
  border-radius: var(--size-border-radius-md);
  color: var(--color-accent-secondary-default);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 700;
  height: 100%;
  justify-content: center;
  text-decoration: none;
  width: 100%;

  :hover {
    background-color: transparent;
    color: var(--color-accent-secondary-default);
  }
`;

export {
  DigitalWrapper,
  DigitalWrapperFeaturedHeader,
  DigitalWrapperSelect,
  DigitalWrapperTitle,
  ImagePreviewWrapper,
  UploadButton,
  UploadImageButtonWrapper
};
